import axios from 'axios';

import { Toast } from 'vant';

import router from '../router';

const http = axios.create({
	timeout: 10000,
	// baseURL: process.env.BASE_FRONT_URL
	baseURL: 'https://api.hermesgames.com.tw/'
})

http.interceptors.request.use(config => {
	if (localStorage.getItem('token')) {
		config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
	}
	config.headers['Content-Type'] = 'application/json'
	return config
}, error => {
	Promise.reject(error)
})

http.interceptors.response.use(response => {
	if (response.status !== 200) {
		Toast("服務器請求超時,請稍後重試!");
	}
	if (response.data.status === 4003) {
		// Toast("登入已過期，請重新登入!");
		localStorage.removeItem('token')
		localStorage.removeItem('userInfo')
    if(router.currentRoute.path === '/memberCenter') {
      router.push('/memberCenter')
    }
	}
	return response.data

}, error => {
	Toast("服務器錯誤，請檢查!");
	setTimeout(() => {
		return Promise.reject(error)
	}, 1000)
})


export default http
